import * as React from 'react'
import {ReactElement} from 'react'
import styled from 'styled-components'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import { Table, TableRow, TableBody, TableCell, Box } from '@mui/material';
import {Colors} from '../../../../styledComponents/Constants'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'

interface Props {
    remandReason: string
    eventEmitter: EventEmitterExAdmin
    onChange: (value: string) => void
}

interface State {
    remandReason: string
}

export default class NatRegistrationApplyRemandForm extends React.Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            remandReason: this.props.remandReason,
        }
        this.handleRemandReasonChange = this.handleRemandReasonChange.bind(this)
    }

    handleRemandReasonChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
                remandReason: event.target.value,
            }, () => {
                this.props.onChange(this.state.remandReason)
            }
        )
    }

    render(): ReactElement {
        return (
            <FormBox>
                <Table>
                    <TableBody>
                        <TableRow>
                            <RowNameCell>差し戻し理由</RowNameCell>
                            <InputCell>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                            placeholder: '申請の差し戻し理由',
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.remandReason}
                                    eventKeys={['memo']}
                                    eventEmitter={this.props.eventEmitter}
                                    onChange={this.handleRemandReasonChange}
                                />
                            </InputCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </FormBox>
        )
    }
}

const FormBox = styled(Box)`
  border: solid 2px ${Colors.Shadow};
  margin: 5px;
  padding: 10px;
`
const RowNameCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  font-size: 1rem;
  line-height: 2.3em;
  vertical-align: top;
  white-space: nowrap;
  padding: 2px 12px 2px 12px;
  }
`
const InputCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  line-height: 2.5em;
  padding: 2px 12px 2px 12px;
  white-space: nowrap;
  width: 100%;
  }
`